import classNames from 'classnames';
import type { HTMLAttributeAnchorTarget } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './DesktopNavigationTabs.module.scss';

export type DesktopNavigationTabsType = {
  title: string;
  path: string;
  active?: boolean;
  disabled?: boolean;
  pathMatchEnd?: boolean;
  className?: string;
  target?: HTMLAttributeAnchorTarget | undefined;
};

export type DesktopNavigationTabsProps = {
  tabs: DesktopNavigationTabsType[];
  size?: 's' | 'm';
  className?: string;
};

export const DesktopNavigationTabs = ({ tabs, size = 'm', className }: DesktopNavigationTabsProps) => {
  return (
    <div
      className={classNames(styles['navigation-tabs'], styles['size-' + size], className)}
      role='tablist'
      aria-orientation='vertical'
    >
      {tabs.map((tab, key) => {
        return tab.disabled ? (
          <div key={key} className={classNames(styles.tab, styles.disabled)}>
            {tab.title}
          </div>
        ) : (
          <NavLink
            to={tab.path}
            key={tab.path}
            className={classNames(styles['nav-link'], tab.className)}
            tabIndex={key}
            target={tab.target}
            end={tab.pathMatchEnd}
          >
            {({ isActive }) => {
              return (
                <div
                  className={classNames(styles.tab, {
                    [styles.active]: tab.active !== undefined ? tab.active : isActive,
                  })}
                >
                  {tab.title}
                </div>
              );
            }}
          </NavLink>
        );
      })}
    </div>
  );
};
